import React from 'react';
import { FileBox, MCButton, MCText, TextAreaField, TextField, View } from 'src/components/basic';
import { lang, number, remCss } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import { MediaDropBox, popupModel, TableLibrary } from 'src/components/complex';
import { BASE_ICONS } from '../svg';
import constants from '../../constants';

export const AddTreatment = ({ closeBtn, item, onSave, hide, currency }) => {
  const [description, setDescription] = React.useState(item?.description);
  const [name, setName] = React.useState(item?.name);
  const [fee, setFee] = React.useState(item?.fee);
  const [media, setMedia] = React.useState(item?.media || []);
  const [files, setFiles] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [invalid, setInvalid] = React.useState({});

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await onSave({ id: item?.id, name, fee, description, media, files });

    if (result.ok) {
      hide();
    } else if (result.invalid) {
      setInvalid(result.invalid);
    }

    setLoading(false);
  };

  return (
    <form className='mc-popup-contain' onSubmit={save} style={{ maxWidth: remCss(600) }}>
      <div className='mc-modal-header'>
        <pre className='mc-popup-title'>
          {lang.t(item?.id ? LANG_CONST.buttons.edit_treatment : LANG_CONST.buttons.add_treatment)}
        </pre>
        {closeBtn}
      </div>
      <div className='mc-modal-body mc-flex-15-col'>
        <div className={'mc-flex-col'}>
          <TextField
            template={6}
            name={'name'}
            label={LANG_CONST.name}
            value={name}
            onChange={(n, v) => {
              setInvalid({});
              setName(v);
            }}
            invalid={invalid}
          />
        </div>
        <div className={'mc-flex-col'}>
          <TextAreaField
            template={6}
            label={LANG_CONST.description}
            value={description}
            onChange={(n, v) => {
              setInvalid({});
              setDescription(v);
            }}
            invalid={invalid}
            rows={3}
            name={'description'}
            placeholder={LANG_CONST.text.enter_word}
          />
        </div>
        <div className={'mc-flex-col'}>
          <TextField
            type={'money'}
            template={6}
            name={'fee'}
            label={LANG_CONST.fee}
            value={fee}
            onChange={(n, v) => {
              setInvalid({});
              setFee(v);
            }}
            invalid={invalid}
            currency={currency}
          />
        </div>
        <div className={'mc-flex-col'}>
          <div className={'mc-label-418'}>{lang.t(LANG_CONST.media)}</div>
          <MediaDropBox
            template={3}
            name={'files'}
            accept={{ 'image/*': [] }}
            labelIcon={lang.t(LANG_CONST.buttons.add_file)}
            multi={true}
            value={files}
            media={media}
            invalid={invalid}
            onChange={(n, v) => {
              setInvalid({});
              setFiles(v);
            }}
            onChangeMedia={(file, index) => {
              setInvalid({});
              setMedia(media.filter((item, i) => i !== index));
            }}
          />
        </div>
      </div>
      <div className='mc-modal-footer mc-flex'>
        <div className='mc-grow' />
        <MCButton
          medium
          primary
          radius
          light
          disabled={loading}
          type={'button'}
          onClick={hide}
          label={LANG_CONST.buttons.cancel}
        />
        <MCButton
          medium
          primary
          radius
          dark
          disabled={loading}
          loading={loading}
          type={'submit'}
          label={lang.t(
            item?.id ? LANG_CONST.buttons.edit_treatment : LANG_CONST.buttons.add_treatment
          )}
        />
      </div>
    </form>
  );
};
export const TreatmentList = ({
  treatments = [],
  onSave,
  onDel,
  onPage,
  currency = constants.general.defaultCurrency
}) => {
  const [pageIndex, setPageIndex] = React.useState(0);
  const listLimit = 3;
  const columns = [
    {
      renderCell: (item) => (
        <View style={{ gap: remCss(10) }}>
          <MCText label={item.name} size={20} textLight />
          <MCText label={item.description} size={20} heading weight={500} />
        </View>
      )
    },
    {
      cellStyles: { textAlign: 'end', alignItems: 'flex-start' },
      width: `${remCss(170)}px`,
      renderCell: (item) => (
        <MCText
          label={item.fee ? number.format(item.fee) + ' ' + currency : ''}
          size={25}
          primary
          weight={600}
        />
      )
    }
  ];

  if (onSave) {
    columns.push({
      cellStyles: { textAlign: 'end', alignItems: 'flex-start' },
      width: `${remCss(170)}px`,
      renderCell: (item) => (
        <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
          <MCButton
            iconname={BASE_ICONS.EDIT}
            light
            radius
            small
            primary
            type='button'
            onClick={() =>
              popupModel.setActivePopup('add_profile_treatment', {
                active: true,
                component: AddTreatment,
                props: {
                  onSave,
                  currency,
                  item: item
                }
              })
            }
          />
          <MCButton
            iconname={BASE_ICONS.DELETE}
            light
            radius
            small
            secondary
            type='button'
            onClick={(e) => {
              e.preventDefault();
              onDel(item.id);
            }}
          />
        </div>
      )
    });
  }

  return (
    <TableLibrary
      className={'mc-mb10 mc-grow'}
      template={3}
      sortBy={null}
      selectedPage={pageIndex}
      total={treatments?.length}
      noResults={!treatments?.length}
      limit={listLimit}
      showHeader={false}
      renderExtend={(item) => {
        return (
          <div
            className={'mc-flex mc-wrap'}
            style={{ marginTop: remCss(-5), gap: remCss(onSave ? 15 : 25) }}
          >
            {(item.media || []).map((file, index) => (
              <FileBox
                list={item.media}
                key={'mc-media-' + index}
                file={file}
                onClose={null}
                styles={{ width: remCss(onSave ? 150 : 300), height: remCss(onSave ? 150 : 300) }}
                onlyPreview={true}
                showFileName={false}
              />
            ))}
          </div>
        );
      }}
      data={treatments.slice(pageIndex * listLimit, (pageIndex + 1) * listLimit)}
      columns={columns}
      onSetPage={(v) => {
        setPageIndex(v);
        onPage && onPage();
      }}
    />
  );
};
